import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';

const darkTheme = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    // backgroundColor: '#000',
    padding: '24px', // Increased padding
    borderRadius: '8px',
    color: '#ccc',
    width: '80%', // Increased width
    // maxHeight: '80%', // Set maximum height
    overflowY: 'auto', // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: '#444',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
  },
};

const BookmarkGrouperModal = (props) => {
  

  return (
    <Modal
        open={props.isModalOpen}
        onClose={props.handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        closeAfterTransition
        // BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={darkTheme.modal}
        id="bookmark-modal"
      >
        <Fade in={props.isModalOpen}>
            <Box  sx={darkTheme.modalContent} >
            <div className="modal-dialog modal-dialog-centered">
                <div className="border modal-content-1 create-folder-modal-content login_modal_wrapper " >
                    <div className="modal-header">
                        <h5 className="modal-title">Add a new folder <i className="fas fa-folder-plus"></i></h5>
                        <button type="button" className="btn-close btn-close-white left-col-space text-white " data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                    <div className="modal-body text-center">
                        <div className="dropdown-search-dashboard">
                            <div className="search-input-wrapper">
                                <input className="modal-input non-capitalise" type="text" placeholder="Enter folder name" value= {props.bookmarkGrouperInput} onChange={props.handleChangeInput} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn secondary_btn" onClick={props.handleClick} >Create</button>
                    </div>
                </div>
            </div>
            </Box>
          </Fade>
    </Modal>
  );
};

export default BookmarkGrouperModal;
